import { 
    loginUser,
    logoutUser,
    getCurrentUser, 
    impersonateUserRequest, 
    getMarketsRequest, 
    stopImpersonatingRequest 
} from '../services/api';
import { requestFreights } from './marketsActions';
import { socketRegisterUser, socketUnregisterUser } from './socketActions';
import { deleteCookie, getCookie } from '../services/cookie';
import { browserHistory } from 'react-router';
import appConfig from '../config/app-config';

import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    CURRENT_USER_REQUEST,
    CURRENT_USER_SUCCESS,
    CURRENT_USER_FAIL,
    SHOW_LOGIN,
    HIDE_LOGIN,
    SHOW_POPUP,
    MARKET_RESET_STATE,
    IMPERSONATE_SUCCESS,
    REFRESH_COMPANY_ID,
    IMPERSONATE_FAIL,
    HIDE_USER_POPUP
} from '../constants/action-types';

export function showLogin(isExpired) {
    return {
        type: SHOW_LOGIN,
        isExpired
    }
}

export function autoLogin(cb) {
    return (dispatch) => {
        dispatch({type: CURRENT_USER_REQUEST});
        dispatch(requestFreights());
        getCurrentUser().then( result => {
            dispatch({
                type: CURRENT_USER_SUCCESS,
                payload: result.data
            });            
            if (typeof cb == 'function') cb();
            dispatch(socketRegisterUser(result.data.id));
        }).catch( error => {
            dispatch({
                type: CURRENT_USER_FAIL,
                error: error
            });
        });
    }
}

export function submitLogin(loginProps, clearForm) {
    return (dispatch) => {
        loginUser(loginProps).then( result => {
            dispatch({type: HIDE_LOGIN});
            dispatch({
                type: LOGIN_SUCCESS,
                payload: result.data
            });
            dispatch(autoLogin());        
            browserHistory.push('/onlinemarkets');
            if (typeof clearForm === 'function') {
                clearForm();
            }
        }).catch( error => {
            dispatch({
                type: LOGIN_FAIL,
                error: error
            });
            if (error.response.status !== 418 && error.response.status !== 417) {
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'Error',
                        content: 'Invalid credentials',
                        buttonText: 'Dismiss'
                    }
                });
            }
        });
    }
}

export function logout() {
    return (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Logout',
                content: 'You are about to logout. Are you sure you want to do this?',
                isConfirm: true,
                buttonAction: () => {
                    logoutUser(getCookie(appConfig.authtoken))
                    .then(() => {
                        if (!getCookie(appConfig.authtoken_impersonate)) {
                            return Promise.resolve();
                        }

                        return logoutUser(getCookie(appConfig.authtoken_impersonate));
                    })
                    .then(() => {
                        dispatch(socketUnregisterUser());
                        dispatch({ type: LOGOUT });
                        dispatch({ type: MARKET_RESET_STATE });
                        deleteCookie(appConfig.authtoken);
                        deleteCookie(appConfig.authtoken_impersonate);
                        browserHistory.push('/');
                    });                    
                }
            }
        });
    }
}

export function instantLogout() {
    return (dispatch) => {
        dispatch({ type: LOGOUT });
        deleteCookie(appConfig.authtoken);
        deleteCookie(appConfig.authtoken_impersonate);
        hidePopupsAndRefresh(dispatch);
    }
}

function hidePopupsAndRefresh(dispatch) {
    dispatch({ type: MARKET_RESET_STATE });
    dispatch({ type: 'HIDE_POPUP' });
    dispatch({ type: 'HIDE_USER_POPUP' });
    dispatch({ type: 'HIDE_MANAGE_MARKET_POPUP' });
    dispatch({ type: 'HIDE_MANAGE_PRODUCT_POPUP' });
    dispatch({ type: 'HIDE_ORDER_POPUP' });
    dispatch({ type: 'HIDE_EXPIRED_ORDERS_POPUP' });
    dispatch({ type: 'HIDE_COMPLETED_TRADES_POPUP' });
    dispatch({ type: 'HIDE_BID_POPUP' });
    dispatch({ type: 'HIDE_INDICES_POPUP' });
    dispatch({ type: 'HIDE_FREIGHT_TYPES_POPUP' });
    browserHistory.push('/');
}

export function impersonateUser(user_id) {
    return (dispatch) => {
        impersonateUserRequest(user_id).then(result => {
            dispatch({
                type: IMPERSONATE_SUCCESS,
                payload: result.data
            });            
            dispatch({ type: HIDE_USER_POPUP });
            dispatch(autoLogin());
            browserHistory.push('/onlinemarkets');
        }).catch( error => {
            dispatch({
                type: IMPERSONATE_FAIL,
                error: error
            });            
        });
    }
}

export function stopImpersonating() {
    return (dispatch) => {
        logoutUser(getCookie(appConfig.authtoken_impersonate)).then(() => {
            deleteCookie(appConfig.authtoken_impersonate);
            dispatch(autoLogin());
            dispatch({
                type: REFRESH_COMPANY_ID,
            });
            hidePopupsAndRefresh(dispatch);
        });        
    }
}



// WEBPACK FOOTER //
// ./source/actions/userActions.js